/**
 * Keep the scrubber where the visitor left it when /api/fires returns 200.
 * A successful poll used to slam the playhead to LIVE and interrupt Play.
 */
export function nextPlayheadAfterRefresh(opts: {
  playing: boolean;
  /** 0–1000 range slider. 1000 = LIVE. */
  sliderPermille: number;
  previousPlayheadMs: number;
  windowSinceMs: number;
  windowUntilMs: number;
}): number {
  const keep = opts.playing || opts.sliderPermille < 1000;
  const raw = keep ? opts.previousPlayheadMs : opts.windowUntilMs;
  return Math.min(opts.windowUntilMs, Math.max(opts.windowSinceMs, raw));
}

/** First satellite look that actually sits in the scrubber window. */
export function firstLookInWindow(timesMs: number[], sinceMs: number, untilMs: number): number | null {
  let best: number | null = null;
  for (const t of timesMs) {
    if (!Number.isFinite(t) || t < sinceMs || t > untilMs) continue;
    if (best == null || t < best) best = t;
  }
  return best;
}

/**
 * Tick positions for the time slider. One mark per look, coarsened when a
 * 7-day MTG stare would paint hundreds of ticks.
 */
export function eventLookMarks(timesMs: number[], sinceMs: number, untilMs: number, max = 40): number[] {
  const inWin: number[] = [];
  const seen = new Set<number>();
  for (const t of timesMs) {
    if (!Number.isFinite(t) || t < sinceMs || t > untilMs) continue;
    if (seen.has(t)) continue;
    seen.add(t);
    inWin.push(t);
  }
  inWin.sort((a, b) => a - b);
  if (inWin.length <= max) return inWin;
  const span = Math.max(1, untilMs - sinceMs);
  const step = Math.max(10 * 60 * 1000, Math.ceil(span / max));
  const buckets = new Map<number, number>();
  for (const t of inWin) {
    const b = Math.floor(t / step) * step;
    if (!buckets.has(b)) buckets.set(b, t);
  }
  return [...buckets.values()].sort((a, b) => a - b).slice(0, max);
}
